import { CallingTheme, EndCallButton, EndCallButtonProps, useTheme } from "@azure/communication-react";
import React, { useCallback } from "react";
import { LeaveLessonDialog } from "../BaseComponents";
import { ButtonSize, endCallButtonStyles, pcpComponentsLightTheme } from "../../styles";
import { Theme } from "@fluentui/react";
import { EndCallIcon } from "../Icons";

interface EndCallButtonWithConfirmProps extends EndCallButtonProps {
    title: string;
    content: string;
    outerSize?: ButtonSize;
}


export const EndCallButtonWithConfirm = (props: EndCallButtonWithConfirmProps) => {

    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const themeV8 = useTheme() as Theme & CallingTheme;  //using value of "FluentThemeProvider" component
    const onRenderIcon = useCallback(() => <EndCallIcon />, []);

    return (
        <>
            <LeaveLessonDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onConfirmLeave={() => {
                    setIsDialogOpen(false);
                    props.onHangUp ? props.onHangUp() : Promise.resolve();
                }}

                title={props.title}
                content={props.content}
            />

            <EndCallButton
                {...props}
                styles={endCallButtonStyles(themeV8, props.outerSize)}
                onRenderIcon={onRenderIcon}
                theme={themeV8}
                onHangUp={() => {
                    setIsDialogOpen(true);
                    return Promise.resolve();
                }}
            />
        </>
    );
};
